import { render, staticRenderFns } from "./businessTableHisList.vue?vue&type=template&id=f61a2abc&scoped=true"
import script from "./businessTableHisList.vue?vue&type=script&lang=js"
export * from "./businessTableHisList.vue?vue&type=script&lang=js"
import style0 from "./businessTableHisList.vue?vue&type=style&index=0&id=f61a2abc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61a2abc",
  null
  
)

export default component.exports